import { PaginatedData } from '../shared/models/table';

export interface AddressBookSearchParams {
  channelsMsisdnsIds?: number[];
  phrase?: string;
  pager: {
    limit: number;
    page: number;
  };
  sortBy?: string;
  order?: string;
  showContactsWithEmptyName?: boolean;
}

export interface AddressBookItem {
  id: number;
  msisdns?: string[];
  contactName?: string;
  contactSurname?: string;
  contactEmail?: string;
  companyName?: string;
}

export interface AddressBookState {
  addressBook: PaginatedData<AddressBookItem>;
  params: AddressBookSearchParams;
}

export const defaultAddressBookPager = {
  limit: 10,
  page: 0
};
